module.exports = __webpack_public_path__ + "img/ntpp-board.f3e9ce68.png";